import { render, staticRenderFns } from "./LabstaffRootView.vue?vue&type=template&id=71b6dc72"
import script from "./LabstaffRootView.vue?vue&type=script&lang=js"
export * from "./LabstaffRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports